import { getSurroundFinishProfile } from '../../../helpers/finish-profiles';

import type { Island } from '../../islands/island.class';

/**
 * Whether this island's finish ships separate corner trim hardware.
 *
 * Read off the finish profile rather than tested against a material name, so adding a finish family
 * that has no trims is one `hasCornerTrims: false` in `finishProfiles` and no branching anywhere else
 * -- which is the rule that file's header already sets out. The trim collection, the trim reset and
 * the renderer all ask this one question, so the model and the drawing cannot disagree (GitHub #467).
 * @param island the island whose finish decides it
 * @returns true when corner trims exist for this finish
 */
export const islandHasCornerTrims = (island: Island | null): boolean => {
	if (!island) return false;

	return getSurroundFinishProfile(island.surround?.material)?.hasCornerTrims ?? true;
};
